export default {
  'share.whatsapp.tip': 'قد لا يتم تثبيت WhatsApp على هاتفك، قم بتثبيته وإعادة المحاولة.',
  'share.ok': 'حسنا',
  'share.install': 'قم تحميل تطبيق soundi الآن',
  'share.download': 'تحميل',
  'share.play': 'العب على راديو soundi',
  'share.live': 'بث مباشر'
};
